import axios from 'axios';
import config from '../Config';

// Cuando a un usuario sin sesión se lo manda a /login desde una acción
// concreta (ej. "chatear con esta modelo"), sin esto perdía esa intención:
// volvía a caer en la home de su rol de siempre, sin ninguna pista de que
// quería iniciar una conversación puntual. `resumeAction` viaja como
// location.state en el push a /login (no por query string: no necesita
// sanitizarse como una URL, y nadie más que nuestro propio código lo setea),
// y esto resuelve a qué ruta final hay que mandar al usuario una vez que el
// login efectivamente terminó.
export async function resolveResumeActionPath(resumeAction, token, role) {
    if (!resumeAction || !token) return null;

    if (resumeAction.type === 'startChat' && resumeAction.modelUserId) {
        try {
            const response = await axios.post(
                `${config.REACT_APP_BASE_URL}/api/v1/chat/start/${resumeAction.modelUserId}`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return `/${role || 'client'}/chat/${response.data.id}`;
        } catch (error) {
            console.error('No se pudo reanudar el chat tras iniciar sesión:', error);
            return null;
        }
    }

    return null;
}
